import FontOutlineHelper from "./FontOutlineHelper";
import {computed, ComputedRef, Ref, ref, toRefs} from "vue";
import textEditWrapper from "./textEditWrapper";

import {ColorUtilsVue} from "@km/js/ColorUtilsVue";
import {EventVerteiler} from "@k/global/eventVerteiler";
import {CONTROLLER_EVENTNAMES} from "@k/global/GlobalEventnames";

export class ModuleTextEditFunctions {

    public static outlineThicknessChangeAllowed:Ref;
    public static currentSelOb:Ref;
    public static textColorValue: ComputedRef<string>;
    public static outlineColorValue: ComputedRef<string>;
    public static hasOutline: ComputedRef<boolean>;
    public static nooutlineclass: ComputedRef<string>;

    public static init(props) {
        ModuleTextEditFunctions.createRefs(props);
        ModuleTextEditFunctions.createComputed();
        textEditWrapper.setChangeHandler((value)=>
            EventVerteiler.broadcast(CONTROLLER_EVENTNAMES.CHANGESELOBWITHHISTORY, {
                id: ModuleTextEditFunctions.currentSelOb.value.id,
                changedProperties: {value: value}
            })
        );
    }

    private static createRefs(props) {
        ModuleTextEditFunctions.outlineThicknessChangeAllowed = ref({up:false,down:false});
        const {currentSelOb} = toRefs(props);
        ModuleTextEditFunctions.currentSelOb = currentSelOb;
    }

    public static isOutlineThicknessChangeAllowed() {
        const {up, down} = FontOutlineHelper.outlineThicknessChangeAllowed(ModuleTextEditFunctions.currentSelOb.value);
        this.outlineThicknessChangeAllowed.value.up = up;
        this.outlineThicknessChangeAllowed.value.down = down;
    }

    private static createComputed() {
        const self = ModuleTextEditFunctions;
        self.textColorValue = computed(()=> ColorUtilsVue.hexWithPoundsign(self.currentSelOb.value));
        self.outlineColorValue = computed(()=>self.currentSelOb.value.outlineColorValue === "<none>" ? "transparent" :
            ColorUtilsVue.hexWithPoundsign(self.currentSelOb.value, "outlineColorValue"));
        self.hasOutline = computed(()=> self.currentSelOb.value.outlineColorValue !== "<none>");
        self.nooutlineclass = computed(()=>self.hasOutline ? '' : "nooutline");
    }

    public static changeTextvalue = (value)=>textEditWrapper.addChange(value);
    public static fontOutlineIncrease = ()=>FontOutlineHelper.fontOutlineIncrease(ModuleTextEditFunctions.currentSelOb.value);
    public static fontOutlineDecrease = ()=>FontOutlineHelper.fontOutlineDecrease(ModuleTextEditFunctions.currentSelOb.value);

}
